<template>
  <div>

    <el-row style="margin-bottom:10px;">

      <el-col  >
        <el-button
        v-if="addProjectVisitorClass"
           @click="$form('addProjectVisitorClass'),getUserVisitorClassList({pageSize:0})"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加官方拜访类型
        </el-button>
        <el-button
        v-if="addProjectVisitorClassCustomize"
           @click="$form('addProjectVisitorClassCustomize')"
          size='small'
          type="primary"
          style="float:right;margin:0 20px;"
          icon='el-icon-circle-plus'
        >添加自定义拜访类型
        </el-button>
      </el-col>
    </el-row>
    <myform view.addProjectVisitorClass="项目拜访分类" 
      @close='$form("addProjectVisitorClass","reset"),getProjectVisitorClassList({projectId})'  @confirm='myformAddProjectVisitorClass' >

      <template v-slot:uvcIds="{Myformdata}">
        <el-select v-model='Myformdata.uvcIds' clearable multiple>
          <el-option v-for="item in getUserVisitorClassList_data.data||[]" :key="item.uvcId" :label="item.uvcName"
            :value="item.uvcId">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-circle-plus"
          @click="$form('addProjectVisitorClass','submit').then(s=>{

          })">添加
        </el-button>

     </template>
    <hide slot='projectId'/>


    </myform>
    <myform view.addProjectVisitorClassCustomize="项目自定义拜访分类" 
      @close='$form("addProjectVisitorClassCustomize","reset"),getProjectVisitorClassList({projectId})'  @confirm='myformAddProjectVisitorClass'  >

      <div style="display: flex;flex-direction: row-reverse;width: 100%;">
        <el-button type="primary" icon="el-icon-circle-plus"
    @click="$form('addProjectVisitorClassCustomize','submit').then(s=>getProjectVisitorClassList({projectId}))">
    添加</el-button>
      </div>
   
    <hide slot='projectId'/>


    </myform>

    <mytable :tableColums='tableColums_getProjectVisitorClassList' api='getProjectVisitorClassList'
      xupdateapi='updateBusinessIntroduce' :height="H-165">
      <div slot="uvcId" slot-scope="{row}" style="max-height: 30vh;overflow: hidden;max-width: 99%;">
          <span v-if="row.uvcId" style="color: green;">是</span>
           <span v-else style="color: red;">不是</span>
      </div>
    </mytable>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        biId: null,
        theMtId: "",
        tableColums_getProjectVisitorClassList: {
          $selection: false,
          uvcName: '拜访名称',
          

          uvcId: '是否官方',
          $operation: this.deleteProjectVisitorClass && [
            '操作', 200,

            `@text: 删除#danger
            @click: _confirm('确定要删除吗?')
                   .trigger('deleteProjectVisitorClass',{pvcId:$row.pvcId})
                   .trigger('getProjectVisitorClassList',{projectId})
          `,
          ],


        },

      };
    },

    watch: {

    },

    methods: {
      myformAddProjectVisitorClass(submit, Myformdata) {
      Myformdata.projectId = A.local('$projectId');
      submit();
    },
    },

    created() {
      console.log(A.local())
      this.getProjectVisitorClassList({projectId:A.local('$projectId')});
       this.projectId=A.local('$projectId')
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/ProjectBfTpye.vue